import { useEffect } from "react";
import { toScroll } from "../../../utils/to-scroll";
import { Main } from "../../components"

export const Financeiro = () => {
  useEffect(() => {
    toScroll()
  }, []);

  return (
    <Main>
      <section id="balance-sheets" className="services">
        <div className="container padding-top-bottom" data-aos="fade-up">
          <div className="section-title">
            <h2>Balancetes</h2>
          </div>

          <div className="row">
            <a href="https://drive.google.com/file/d/1RkSQqgYC7CHtZuaREeQcGIZlO9a9M9bK/view" target="_blank" rel="noreferrer">
              <div className="col-xl-3 col-md-6 d-flex align-items-stretch" data-aos="zoom-in" data-aos-delay="100">
                <div className="icon-box pdf-icon-box d-flex align-items-center flex-column">
                  <div className="icon">
                    <img className="pdf-icon" src="/assets/img/pdf-icon.png" alt="" />
                  </div>
                  <h4>Fluxode Caixa 2022</h4>
                </div>
              </div>
            </a>
          </div>
        </div>
      </section>

      <section id="patrimony-balance-sheet" className="services section-bg">
        <div className="container padding-top-bottom" data-aos="fade-up">
          <div className="section-title">
            <h2>Balanço Patrimonial</h2>
          </div>
          <div className="row mb-4">
            <div className="col-xl-3 col-md-6 d-flex align-items-stretch" data-aos="zoom-in" data-aos-delay="100">
              <div className="icon-box pdf-icon-box d-flex align-items-center flex-column">
                <div className="icon">
                  <img className="pdf-icon" src="/assets/img/pdf-icon.png" alt="" />
                </div>
                <h4>
                  <a target="_blank"
                    href="https://drive.google.com/file/d/1K1GWFkhA8XaYkvXq0Pp-xJKxLQ_t3wQL/view" rel="noreferrer">
                    Declaração sem movimento 2021
                  </a>
                </h4>
              </div>
            </div>
            <div className="col-xl-3 col-md-6 d-flex align-items-stretch" data-aos="zoom-in" data-aos-delay="100">
              <div className="icon-box pdf-icon-box d-flex align-items-center flex-column">
                <div className="icon">
                  <img className="pdf-icon" src="/assets/img/pdf-icon.png" alt="" />
                </div>
                <h4>
                  <a target="_blank" href="https://drive.google.com/file/d/1a3lHQtgxNDVX5g4iO_vXrSeqsjHWW32H/view" rel="noreferrer">
                    Balanço Patrimonial AAT 2022
                  </a>
                </h4>
              </div>
            </div>
            <div className="col-xl-3 col-md-6 d-flex align-items-stretch" data-aos="zoom-in" data-aos-delay="100">
              <div className="icon-box pdf-icon-box d-flex align-items-center flex-column">
                <div className="icon">
                  <img className="pdf-icon" src="/assets/img/pdf-icon.png" alt="" />
                </div>
                <h4>
                  <a target="_blank" href="https://drive.google.com/file/d/14M14qqvMZfUMfxyN_F_eIzE68908dwWz/view" rel="noreferrer">
                    Balanço Patrimonial AAT 2023
                  </a>
                </h4>
              </div>
            </div>
            <div className="col-xl-3 col-md-6 d-flex align-items-stretch" data-aos="zoom-in" data-aos-delay="100">
              <div className="icon-box pdf-icon-box d-flex align-items-center flex-column">
                <div className="icon">
                  <img className="pdf-icon" src="/assets/img/pdf-icon.png" alt="" />
                </div>
                <h4>
                  <a target="_blank" href="https://drive.google.com/file/d/1CsTMGvFuVkuGHSrKlPk4KnbNRg6wtovb/view" rel="noreferrer">
                    Balanço Patrimonial AAT 2024
                  </a>
                </h4>
              </div>
            </div>

            <div className="col-xl-3 col-md-6 d-flex align-items-stretch" data-aos="zoom-in" data-aos-delay="100">
              <div className="icon-box pdf-icon-box d-flex align-items-center flex-column">
                <div className="icon">
                  <img className="pdf-icon" src="/assets/img/pdf-icon.png" alt="" />
                </div>
                <h4>
                  <a target="_blank" href="https://drive.google.com/file/d/1OJJJM98hooe0b6kQK60x4cX70hE1EMmV/view" rel="noreferrer">
                    Balanço Patrimonial AAT 2025
                  </a>
                </h4>
              </div>
            </div>            

          </div>
        </div>
      </section>

      <section id="index-composition" className="services">
        <div className="container padding-top-bottom" data-aos="fade-up">
          <div className="section-title">
            <h2>Composição De Índices</h2>
          </div>

          <div className="row">
            <div className="col-xl-3 col-md-6 d-flex align-items-stretch" data-aos="zoom-in" data-aos-delay="100">
              <div className="icon-box pdf-icon-box d-flex align-items-center flex-column">
                <div className="icon">
                  <img className="pdf-icon" src="/assets/img/pdf-icon.png" alt="" />
                </div>
                <h4>
                  <a target="_blank" href="https://drive.google.com/file/d/1qXj-Fq6DJudj8mXswZsGUGSo63-lZe-C/view" rel="noreferrer">
                    COMPOSIÇÃO DE ÍNDICES DO ART. 4º DA PORTARIA 115-2018
                    2022
                  </a>
                </h4>
              </div>
            </div>
            <div className="col-xl-3 col-md-6 d-flex align-items-stretch" data-aos="zoom-in" data-aos-delay="100">
              <div className="icon-box pdf-icon-box d-flex align-items-center flex-column">
                <div className="icon">
                  <img className="pdf-icon" src="/assets/img/pdf-icon.png" alt="" />
                </div>
                <h4>
                  <a target="_blank" href="https://drive.google.com/file/d/19h5CR_3BPU6CR5VGn4uYK98E3CrIQbV_/" rel="noreferrer">
                    COMPOSIÇÃO DE ÍNDICES DO ART. 4º DA PORTARIA 115-2018
                    2023
                  </a>
                </h4>
              </div>
            </div>
            <div className="col-xl-3 col-md-6 d-flex align-items-stretch" data-aos="zoom-in" data-aos-delay="100">
              <div className="icon-box pdf-icon-box d-flex align-items-center flex-column">
                <div className="icon">
                  <img className="pdf-icon" src="/assets/img/pdf-icon.png" alt="" />
                </div>
                <h4>
                  <a target="_blank" href="https://drive.google.com/file/d/1qKoN7fTPfFTNg6ON4F8UhtznOjE9eHyC" rel="noreferrer">
                    COMPOSIÇÃO DE ÍNDICES DO ART. 4º DA PORTARIA 115-2018
                    2024
                  </a>
                </h4>
              </div>
            </div>

            <div className="col-xl-3 col-md-6 d-flex align-items-stretch" data-aos="zoom-in" data-aos-delay="100">
              <div className="icon-box pdf-icon-box d-flex align-items-center flex-column">
                <div className="icon">
                  <img className="pdf-icon" src="/assets/img/pdf-icon.png" alt="" />
                </div>
                <h4>
                  <a target="_blank" href="https://drive.google.com/file/d/1MwoZ58GAK76hhAi2Ffb0JalvAwTXf7Xh/view" rel="noreferrer">
                    COMPOSIÇÃO DE ÍNDICES DO ART. 4º DA PORTARIA 115-2018 - 2026
                    2024
                  </a>
                </h4>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="payments-statement" className="services section-bg">
        <div className="container padding-top-bottom" data-aos="fade-up">
          <div className="section-title">
            <h2>Memória de Cálculo de Índices</h2>
          </div>
          <div className="row">

            <div className="col-xl-3 col-md-6 d-flex align-items-stretch" data-aos="zoom-in" data-aos-delay="100">
              <div className="icon-box pdf-icon-box d-flex align-items-center flex-column">
                <div className="icon">
                  <img className="pdf-icon" src="/assets/img/pdf-icon.png" alt="" />
                </div>
                <h4>
                  <a target="_blank"
                    href="https://drive.google.com/file/d/1M-FxucdJkTkuBB7Yu4NpBNiQkAqjIc2B/view" rel="noreferrer">
                    Memória de Cálculo 2022
                  </a>
                </h4>
              </div>
            </div>

            <div className="col-xl-3 col-md-6 d-flex align-items-stretch" data-aos="zoom-in" data-aos-delay="100">
              <div className="icon-box pdf-icon-box d-flex align-items-center flex-column">
                <div className="icon">
                  <img className="pdf-icon" src="/assets/img/pdf-icon.png" alt="" />
                </div>
                <h4>
                  <a target="_blank"
                    href="https://drive.google.com/file/d/1v_7u2bjGjYojstHgkMCDBMAmc6StM1uA/view" rel="noreferrer">
                    Memória de Cálculo 2023
                  </a>
                </h4>
              </div>
            </div>

            <div className="col-xl-3 col-md-6 d-flex align-items-stretch" data-aos="zoom-in" data-aos-delay="100">
              <div className="icon-box pdf-icon-box d-flex align-items-center flex-column">
                <div className="icon">
                  <img className="pdf-icon" src="/assets/img/pdf-icon.png" alt="" />
                </div>
                <h4>
                  <a target="_blank"
                    href="https://drive.google.com/file/d/1k3TAMgLHGsHdFi2orLAG6GvYoa3WuApT/view" rel="noreferrer">
                    Memória de Cálculo 2024
                  </a>
                </h4>
              </div>
            </div>

            <div className="col-xl-3 col-md-6 d-flex align-items-stretch" data-aos="zoom-in" data-aos-delay="100">
              <div className="icon-box pdf-icon-box d-flex align-items-center flex-column">
                <div className="icon">
                  <img className="pdf-icon" src="/assets/img/pdf-icon.png" alt="" />
                </div>
                <h4>
                  <a target="_blank" href="https://drive.google.com/file/d/1GNf18iie3-kzhDePWjoSL8ud2e-Jqo5-/view" rel="noreferrer">
                    Memória de cálculo 2025
                  </a>
                </h4>
              </div>
            </div>

          </div>

        </div>
      </section>

      <section id="payments-statement" className="services section-bg">
        <div className="container padding-top-bottom" data-aos="fade-up">
          <div className="section-title">
            <h2>Demonstrativo De Pagamento De Beneficiários</h2>
          </div>
          <div className="row">
            <div className="col-xl-3 col-md-6 d-flex align-items-stretch" data-aos="zoom-in" data-aos-delay="100">
              <div className="icon-box pdf-icon-box d-flex align-items-center flex-column">
                <div className="icon">
                  <img className="pdf-icon" src="/assets/img/pdf-icon.png" alt="" />
                </div>
                <h4>
                  <a target="_blank"
                    href="https://drive.google.com/file/d/185zIBIIrZbdUTiBOQZCt-e9mL5m71-BY/view" rel="noreferrer">
                    Relação de recursos humanos contratados
                  </a>
                </h4>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="dre" className="services">
        <div className="container padding-top-bottom" data-aos="fade-up">
          <div className="section-title">
            <h2>DRE</h2>
          </div>

          <div className="row">
            <div className="col-xl-3 col-md-6 d-flex align-items-stretch" data-aos="zoom-in" data-aos-delay="100">
              <div className="icon-box pdf-icon-box d-flex align-items-center flex-column">
                <div className="icon">
                  <img className="pdf-icon" src="/assets/img/pdf-icon.png" alt="" />
                </div>
                <h4>
                  <a target="_blank"
                    href="https://drive.google.com/file/d/1Ifg_dYg2DLHBajvVM0jKunVtil-E83v3/view" rel="noreferrer">
                    DRE 2022
                  </a>
                </h4>
              </div>
            </div>
            <div className="col-xl-3 col-md-6 d-flex align-items-stretch" data-aos="zoom-in" data-aos-delay="100">
              <div className="icon-box pdf-icon-box d-flex align-items-center flex-column">
                <div className="icon">
                  <img className="pdf-icon" src="/assets/img/pdf-icon.png" alt="" />
                </div>
                <h4>
                  <a target="_blank"
                    href="https://drive.google.com/file/d/1wiZYtTBTSd86R--JuHU9eOl2SMZCdNaY/view" rel="noreferrer">
                    DRE 2023
                  </a>
                </h4>
              </div>
            </div>
            <div className="col-xl-3 col-md-6 d-flex align-items-stretch" data-aos="zoom-in" data-aos-delay="100">
              <div className="icon-box pdf-icon-box d-flex align-items-center flex-column">
                <div className="icon">
                  <img className="pdf-icon" src="/assets/img/pdf-icon.png" alt="" />
                </div>
                <h4>
                  <a target="_blank"
                    href="https://drive.google.com/file/d/1d7OAi0jpvQ4d8lU7Iwfxr0ou6kwETCuk/view" rel="noreferrer">
                    DRE 2024
                  </a>
                </h4>
              </div>
            </div>

            <div className="col-xl-3 col-md-6 d-flex align-items-stretch" data-aos="zoom-in" data-aos-delay="100">
              <div className="icon-box pdf-icon-box d-flex align-items-center flex-column">
                <div className="icon">
                  <img className="pdf-icon" src="/assets/img/pdf-icon.png" alt="" />
                </div>
                <h4>
                  <a target="_blank"
                    href="https://drive.google.com/file/d/1v6RP-xTXbR6DaaFDRhnqsMhyZs3SsaE2/view" rel="noreferrer">
                    DRE 2025
                  </a>
                </h4>
              </div>
            </div>

            <div className="col-xl-3 col-md-6 d-flex align-items-stretch" data-aos="zoom-in" data-aos-delay="100">
              <div className="icon-box pdf-icon-box d-flex align-items-center flex-column">
                <div className="icon">
                  <img className="pdf-icon" src="/assets/img/pdf-icon.png" alt="" />
                </div>
                <h4>
                  <a target="_blank"
                    href="https://drive.google.com/file/d/1K1GWFkhA8XaYkvXq0Pp-xJKxLQ_t3wQL/view" rel="noreferrer">
                    Declaração sem movimento 2021
                  </a>
                </h4>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Main>
  )
}